import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  bottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: "100%",
    top: -20,
    width: "100%",
  },
  bottomContentContainer: { flex: 1, marginTop: 50, padding: 10 },
  button: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 15,
  },
  buttonIconContainer: {
    alignItems: "center",
    borderRadius: 999,
    height: 35,
    justifyContent: "center",
    marginRight: 10,
    width: 35,
  },
  buttonText: { fontFamily: typography.primary.normal },
  buttonTextContainer: { alignItems: "center", flexDirection: "row" },
  container: { height: "100%", padding: 10 },
  flatlistContainer: { marginTop: 10, padding: 1 },
  headerSingleUsername: { color: colors.lightGrey, fontSize: 50 },
  overHeadButton: {
    alignItems: "center",
    backgroundColor: colors.lighterGrey,
    borderRadius: 999,
    flex: 1,
    justifyContent: "center",
  },
  overHeadContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 999,
    borderWidth: 8,
    height: 100,
    position: "absolute",
    top: -50,
    width: 100,
    zIndex: 999,
  },

  profilePictureImage: { borderRadius: 999, flex: 1, height: "100%", width: "100%" },
  separator: { backgroundColor: colors.placeholder, height: 0.5 },
  usernameText: { fontFamily: typography.primary.normal, fontSize: 24, marginBottom: 10 },
})
